import type { PatientI18n } from "~/patient_i18n/i18n";
import { LegalPageLayout } from "./_layout";

type Props = {
  locationName: string;
  logoUrl: string | null;
  addressLines: string[] | null;
  phone: string | null;
  content: string;
  patientI18n: PatientI18n;
};

export default function PrivacyPolicy(props: Props) {
  return (
    <LegalPageLayout
      page="privacy"
      locationName={props.locationName}
      logoUrl={props.logoUrl}
      addressLines={props.addressLines}
      phone={props.phone}
      content={props.content}
      patientI18n={props.patientI18n}
    />
  );
}
